import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { downloadXlsx, fetchInterested } from "@/lib/bf";
import { fetchUsers } from "@/lib/api";

const BR = [["", "Toate brandurile"], ["medavita", "Medavita"], ["framesi", "Framesi"], ["lalga", "L'Alga"], ["mowan", "Mowan"]];

export default function BFInterested() {
  const [brand, setBrand] = useState("");
  const [agent, setAgent] = useState("");
  const [agents, setAgents] = useState([]);
  const [rows, setRows] = useState(null);
  useEffect(() => { fetchUsers().then((d) => setAgents(d.users.filter((u) => u.share_slug))).catch(() => {}); }, []);
  useEffect(() => { setRows(null); fetchInterested(brand, agent).then(setRows).catch(() => setRows([])); }, [brand, agent]);
  const xlsx = () => downloadXlsx(`/bf/admin/edu/interested.xlsx?${new URLSearchParams({ brand, agent })}`, "Clienti_interesati_educatie.xlsx").catch(() => toast.error("Nu am putut descărca"));
  return (
    <section className="invite-box" data-testid="bf-interested">
      <h3>Clienți interesați de evenimente {rows ? `(${rows.length})` : ""}</h3>
      <div className="bf-smove-bar">
        <label className="st-field"><span className="st-label">Brand</span><select value={brand} onChange={(e) => setBrand(e.target.value)} data-testid="bf-int-brand">{BR.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
        <label className="st-field"><span className="st-label">Agent</span><select value={agent} onChange={(e) => setAgent(e.target.value)} data-testid="bf-int-agent">
          <option value="">Toți agenții</option><option value="-">Fără agent</option>{agents.map((a) => <option key={a.share_slug} value={a.share_slug}>{a.name || a.email}</option>)}</select></label>
        <button type="button" className="st-btn st-btn--silver" onClick={xlsx} data-testid="bf-int-xlsx"><Download size={14} /> Excel</button>
      </div>
      {!rows ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <ul className="bfc-visits">
          {!rows.length && <li className="st-hint">Niciun client bifat încă.</li>}
          {rows.map((r) => (
            <li key={`${r.lead}-${r.brand}`} data-testid={`bf-int-row-${r.lead}-${r.brand}`}>
              <b>{r.salon} · {BR.find(([k]) => k === r.brand)?.[1]}</b>
              <span>{[r.admin_name, r.city, r.phone].filter(Boolean).join(" · ")}</span>
              <small>agent {r.agent}{r.events.length ? ` · înscris la: ${r.events.join(", ")}` : ""}</small>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
